module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-3-thumb-3389f396.png";